var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-color-picker',{staticClass:"mx-auto",attrs:{"mode":"hexa","hide-mode-switch":true,"hide-inputs":false,"swatches":_vm.swatches,"show-swatches":""},model:{value:(_vm.color),callback:function ($$v) {_vm.color=$$v},expression:"color"}})}
var staticRenderFns = []

export { render, staticRenderFns }